module.exports = __webpack_public_path__ + "media/images/athletes/2798-6b77edbd9f7b7a5bbf2961dd6bb4f29b.png";